import isEmpty from 'lodash/isEmpty';
import uniqBy from 'lodash/uniqBy';
import { formatNextInspection } from '@domain-group/fe-allhomes-library/lib/utils/listing-utils';
import postRequest from './post-request';
var lookupFeaturedProperty = (query, props, state, featuredListingType) => {
  var queryLocalities = query.getLocalities();
  if (!isEmpty(queryLocalities)) {
    var localities = queryLocalities.map(locality => ({
      localityId: locality.id,
      localityType: locality.type
    }));
    return postRequest(props.getAbsoluteUrl(props.endpoints.featuredListingEndpoint), {
      featuredListingType: featuredListingType.name,
      listingType: props.listingType,
      localities
    }).then(results => uniqBy(results.map(property => formatNextInspection(property)), property => property.listing.id))
    // OK, update featuredProperties state
    .then(featuredProperties => ({
      featuredProperties
    })).catch(() => ({
      // reset featuredProperties to original values
      featuredProperties: state.featuredProperties
    }));
  }
  // For multiple locations featuredProperties is empty
  return Promise.resolve({
    featuredProperties: []
  });
};
export default lookupFeaturedProperty;